export enum NotificationDisplayTypeEnum {
  BANNER = 'banner',
  POPUP = 'popup',
  BLOCK = 'full_block'
}